<template>
  <div class="lawn-treatment-view--container">
    <h1 class="lawn-treatment-view--h1">Feed your lawn</h1>
    <h2 class="lawn-treatment-view--h2">
      Our {{ fertilizationCount }}-step comprehensive fertilization and weed control package gives
      your lawn everything it needs.
    </h2>
    <ul class="lawn-treatment-view--ul">
      <li class="lawn-treatment-view--li">
        Kill weeds before they appear
        <LsIcon type="checkmark" class="lawn-treatment-view--checkmark" />
      </li>
      <li class="lawn-treatment-view--li">
        Greener, healthier grass
        <LsIcon type="checkmark" class="lawn-treatment-view--checkmark" />
      </li>
      <li class="lawn-treatment-view--li">
        Eliminate weeds once they sprout
        <LsIcon type="checkmark" class="lawn-treatment-view--checkmark" />
      </li>
      <li class="lawn-treatment-view--li">
        Improve your soil conditions
        <LsIcon type="checkmark" class="lawn-treatment-view--checkmark" />
      </li>
    </ul>
    <div class="columns is-mobile">
      <div class="column is-6 lawn-treatment-view--image-container">
        <p class="lawn-treatment-view--image-text">BEFORE</p>
        <img
          test-id="img"
          :src="require(`../../../../../assets/lawn_treatment/before_lawn_treatment.png`)"
          alt="Before Lawn Treatment"
        />
      </div>
      <div class="column is-6 lawn-treatment-view--image-container">
        <p class="lawn-treatment-view--image-text">AFTER</p>
        <img
          test-id="img"
          :src="require(`../../../../../assets/lawn_treatment/after_lawn_treatment.png`)"
          alt="After Lawn Treatment"
        />
      </div>
    </div>
    <div class="columns is-mobile lawn-treatment-view--information-block">
      <div class="column">
        <h3 class="lawn-treatment-view--h3">Kill Weeds</h3>
        <p class="lawn-treatment-view--p">
          The lowest totem pole in the lawn kingdom is the yard with weeds. Our package works to
          fight weeds before and after they appear.
        </p>
      </div>

      <div v-if="screenSize.desktop" class="column is-1"></div>
      <div class="column is-narrow">
        <img
          test-id="img"
          :src="require(`../../../../../assets/lawn_treatment/kill_weeds.png`)"
          alt="Kill Weeds"
        />
      </div>
    </div>

    <div class="columns is-mobile lawn-treatment-view--information-block">
      <div class="column">
        <h3 class="lawn-treatment-view--h3">Improve Color</h3>
        <p class="lawn-treatment-view--p">
          The best lawns in the neighborhood are luscious and green. With our treatment package you
          can become the envy of the neighborhood.
        </p>
      </div>
      <div v-if="screenSize.desktop" class="column is-1"></div>
      <div class="column is-narrow">
        <img
          test-id="img"
          :src="require(`../../../../../assets/lawn_treatment/improve_color.png`)"
          alt="Improve Color"
        />
      </div>
    </div>

    <div class="columns is-mobile lawn-treatment-view--information-block">
      <div class="column">
        <h3 class="lawn-treatment-view--h3">Healthy Soil</h3>
        <p class="lawn-treatment-view--p">
          A lawn can't be healthy without a strong base. Our program creates just the right biome
          for your grass to grow strong and healthy.
        </p>
      </div>
      <div v-if="screenSize.desktop" class="column is-1"></div>
      <div class="column is-narrow">
        <img
          test-id="img"
          :src="require(`../../../../../assets/lawn_treatment/healthy_soil.png`)"
          alt="Healthy Soil"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { LsIcon } from '@/components/common';
import VueTypes from 'vue-types';
import { mapState } from 'vuex';

export default {
  name: 'OldLawnTreatmentView',
  components: {
    LsIcon,
  },
  props: {
    fertilizationCount: VueTypes.number.isRequired,
  },
  computed: {
    ...mapState(['screenSize']),
  },
};
</script>

<style lang="scss" scoped>
.lawn-treatment-view--checkmark {
  position: relative;
  top: 3px;
}
.lawn-treatment-view--image-container {
  position: relative;
  margin-bottom: 20px;
  padding: 3px;
}
.lawn-treatment-view--image-text {
  position: absolute;
  top: 17px;
  left: 15px;
  font-weight: bold;
  color: white;
}
.lawn-treatment-view--information-block {
  margin-bottom: 20px;

  @media (max-width: $mobile-max-width) {
    border-bottom: 1px solid $primary-light;
    padding-bottom: 20px;
  }
  img {
    position: relative;
    @media (max-width: $mobile-max-width) {
      top: 25%;
      max-height: 64px;
      max-width: 64px;
    }
  }
}
.lawn-treatment-view--column {
  padding: 3px;
}
.lawn-treatment-view--li {
  font-size: $size-5;
  font-weight: bold;
  padding: 15px 0px;
  display: flex;
  justify-content: space-between;
}
.lawn-treatment-view--li:not(:last-child) {
  border-bottom: 1px solid $primary-light;
}
.lawn-treatment-view--ul {
  margin-bottom: 20px;
}

.lawn-treatment-view--h1 {
  font-weight: bold;
  margin-bottom: 3px;
}
.lawn-treatment-view--h2 {
  font-size: $size-4;
  margin-bottom: 20px;
}
.lawn-treatment-view--h3 {
  font-size: $size-4;
  color: $primary;
  margin-bottom: 12px;
}

.themed-app {
  .lawn-treatment-view--information-block {
    @media (max-width: $mobile-max-width) {
      border-bottom-color: $theme-color-primary-light;
    }
  }

  .lawn-treatment-view--li {
    font-size: $theme-txt-body;
  }

  .lawn-treatment-view--li:not(:last-child) {
    border-bottom-color: $theme-color-primary-light;
  }

  .lawn-treatment-view--h2 {
    font-size: $theme-txt-body-lg;
  }

  .lawn-treatment-view--h3 {
    font-size: $theme-txt-body-lg;
    color: $theme-color-primary;
  }
}
</style>
